import script from "./AllChatBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AllChatBox.vue?vue&type=script&setup=true&lang=js"

import "./AllChatBox.vue?vue&type=style&index=0&id=76bd47ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76bd47ac"]])

export default __exports__